import { attachLinkHandlers, dateFormatDefault } from 'bv-services';
import cookiesPolicy from './cookies_policy';
import initDompurify from './dompurify';

export default () => {
  document.getElementById('no-javascript').remove();
  cookiesPolicy();
  attachLinkHandlers('frontend');
  dateFormatDefault();
  initDompurify();
};
